export default __webpack_public_path__ + "d22abc0a8e554823a37824e0740cc04b.svg";